export function toArray(x) { return Array.isArray(x) ? x : [x]; }
export default toArray;

//# sourceMappingURL=toArray.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/reassemble/lib/utils/toArray.js
// module id = 197
// module chunks = 0